<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        :title="`Configuração de SMS - ${item && item.unidadeNomeFantasia}`"
    >
        <rkm-form
            ref="RkmFormSms"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.diaAntecedencia"
                        label="Dias de antecedência"
                        number
                        v-model="model.diaAntecedencia"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-date-picker
                        :end-validations="validations.endDate"
                        :range-inline="false"
                        :start-validations="validations.startDate"
                        end-label="Até"
                        range
                        start-label="Período de envio de"
                        v-model="model.periodoEnvio"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            no-margin-top
            title="Especialidade"
        >
            <rkm-form ref="RkmFormEspecialidade">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.especialidade"
                            :search-fields="searchFields"
                            :text-field="(item) => item.ocupacaoCodigo ? `${item.ocupacaoCodigo} - ${item.nome}` : null"
                            :validations="validations.especialidade"
                            label="Especialidade"
                            v-model="model.especialidade"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="include"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clean"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-table
                :fields="fields"
                :items="model.especialidades"
            >
                <template v-slot:cell(especialidade)="{item}">
                    {{item.ocupacaoCodigo}} - {{item.nome}}
                </template>

                <template v-slot:cell(actions)="{index}">
                    <rkm-button
                        @click="destroy(index)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

export default {
    computed: {
        searchFields() {
            return [
                {key: 'especialidade.nome', searchable: true},
            ]
        },
        validations() {
            return {
                diaAntecedencia: {
                    required: true,
                    max: 3,
                    max_value: 365,
                },
                startDate: {required: true},
                endDate: {required: true},
                especialidade: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            especialidade: this.getConectaSusRepository('cadastro.especialidade'),
        }
    },
    data: () => ({
        fields: [
            {key: 'especialidade', label: 'Especialidade', sortable: true},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
        item: null,
        model: {
            diaAntecedencia: null,
            especialidade: null,
            especialidades: [],
            periodoEnvio: {
                start: null,
                end: null,
            },
        },
        others: {moment},
    }),
    methods: {
        open(item) {
            this.resetFormEspecialidade()

            this.item = item

            if (item) {
                const model = this.clone(item.sms)

                this.model.diaAntecedencia = model.diaAntecedencia,
                this.model.periodoEnvio.start = model.periodoEnvio.start ? this.others.moment(model.periodoEnvio.start, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
                this.model.periodoEnvio.end = model.periodoEnvio.end ? this.others.moment(model.periodoEnvio.end, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
                this.model.especialidades = model.especialidades
            }

            this.$refs.RkmModal.show()
        },
        include() {
            if (this.model.especialidades && this.model.especialidades.find(especialidade => especialidade.id === this.model.especialidade.id)) {
                this.showValidationNotification('A especialidade já foi incluída.')
                return
            }

            this.$refs.RkmFormEspecialidade.validate()
                .then(valid => {
                    if (valid === false) return

                    this.model.especialidades.push({
                        id: this.model.especialidade.id,
                        nome: this.model.especialidade.nome,
                        ocupacaoCodigo: this.model.especialidade.ocupacaoCodigo,
                    })

                    this.resetFormEspecialidade()
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir a especialidade?', async () => {
                this.model.especialidades.splice(index, 1)
            })
        },
        save() {
            this.$refs.RkmFormSms.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item.sms) {
                        this.item.sms.diaAntecedencia = this.model.diaAntecedencia

                        this.item.sms.periodoEnvio = {
                            start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                            end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                        }

                        this.item.sms.especialidades = this.model.especialidades
                    } else {
                        this.item.sms = {
                            diaAntecedencia: this.model.diaAntecedencia,
                            periodoEnvio: {
                                start: this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY'),
                                end: this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY'),
                            },
                            especialidades: this.model.especialidades,
                        }
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        clean() {
            this.resetFormEspecialidade()
        },
        resetFormEspecialidade() {
            this.model.especialidade = null
            this.model.unidadeNomeFantasia = null

            this.$nextTick().then(() => this.$refs.RkmFormEspecialidade.resetValidator())
        },
    },
    mixins: [error, object, repository, stringCase],
}
</script>